import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router } from "@angular/router";
import { LocalStorageService } from "src/app/api/services/localStorage";
import { CompetitorSimple } from "src/app/common/types/competitor";
import { CompetitionAuthorService } from "../services/competition-author.service";
import { catchError } from "rxjs";

export const CompetitionAuthorGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot
  ) => {
  const localStorage = inject(LocalStorageService);
  const router = inject(Router);
  
  if (localStorage.get('loggedCompetitor') === null || localStorage.get('loggedCompetitor') === undefined) {
    router.navigateByUrl('/');
    return false;
  }

  const competitionId = route.paramMap.get('id') ?? route.parent.paramMap.get('id');

  if (!competitionId) {
    router.navigateByUrl('/');
    return false;
  }

  inject(CompetitionAuthorService).isAuthor(competitionId as unknown as number)
  .pipe(catchError(() => {
    return router.navigateByUrl('/');
  }))
  .subscribe((isAuthor: boolean) => {
    if (isAuthor) {
        return true;
    }
    router.navigateByUrl('/');
    return false;
  });
};